<footer class="usa-footer usa-footer--big">
  <div class="usa-footer__primary-section">
    <div class="grid-container">
      <div class="grid-row grid-gap-4 footer-nav">
        <div class="mobile-lg:grid-col-6 desktop:grid-col-3">
          <section class="usa-footer__primary-content usa-footer__primary-content--collapsible">
            <h4 class="usa-footer__primary-link">Need Help?</h4>
            <ul class="usa-list usa-list--unstyled">
              <li class="usa-footer__secondary-link">For further assistance, please contact:</li>
              <li class="usa-footer__secondary-link">Phone: 1-866-668-3472</li>
              <li class="usa-footer__secondary-link">
                Email: <a href="mailto:gsatmsshelp@gsa.gov">gsatmsshelp&#64;gsa.gov</a>
              </li>
            </ul>
          </section>
        </div>
        <div class="mobile-lg:grid-col-6 desktop:grid-col-3">
          <section class="usa-footer__primary-content usa-footer__primary-content--collapsible">
            <h4 class="usa-footer__primary-link">Freight Resources</h4>
            <ul class="usa-list usa-list--unstyled">
              <li class="usa-footer__secondary-link"><a target="_blank"
                                                        href="https://www.gsa.gov/buying-selling/products-services/transportation-logistics-services/transportation-programs">Center
                for Transportation Management</a></li>
              <li class="usa-footer__secondary-link">
                <a target="" href="javascript:void(0)" (click)="downloadTemplate('frtagyuserGuide')">TMSS 2.0
                  Freight
                  Agency User Guide</a>
              </li>
              <li class="usa-footer__secondary-link">
                <a target="" href="javascript:void(0)" (click)="downloadTemplate('frttspuserGuide')">TMSS 2.0
                  Freight
                  TSP User Guide</a>
              </li>
            </ul>
            <h4 class="usa-footer__primary-link">Household Goods Resources</h4>
            <ul class="usa-list usa-list--unstyled">
              <li class="usa-footer__secondary-link">
                <a target="_blank" href="https://hallways.cap.gsa.gov/app/#/">Employee Relocation Resource Center (ERRC) (click on the "Travel" category</a>)
              </li>
              <li class="usa-footer__secondary-link">
                <a target="_blank" href="https://hallways.cap.gsa.gov/app/#/gateway/travel/1086/household-goods-move-management-services%3Ftid=3401?tid=3401">ERRC Reference Library (HTOS/XTOS, RFOs, GSA500A, etc.</a>)
              </li>
              <li class="usa-footer__secondary-link">
                <a target="" href="javascript:void(0)" (click)="downloadTemplate('userGuide')">TMSS 2.0 Household
                  Goods
                  User Guide</a>
              </li>
              <li class="usa-footer__secondary-link">
                <a target="" href="javascript:void(0)" (click)="downloadTemplate('hhgratefilinginstr')">HHG Rate
                  Filing
                  Instructions</a>
              </li>
              <li class="usa-footer__secondary-link">
                <a target="" href="javascript:void(0)" (click)="downloadTemplate('xtosratefilinginstr')">XTOS Rate
                  Filing Instructions</a>
              </li>
            </ul>
          </section>
        </div>
        <div class="mobile-lg:grid-col-6 desktop:grid-col-3">
          <section class="usa-footer__primary-content usa-footer__primary-content--collapsible">
            <h4 class="usa-footer__primary-link">Freight Batch Upload Templates</h4>
            <ul class="usa-list usa-list--unstyled">
              <li class="usa-footer__secondary-link"><a target="" href="javascript:void(0)"
                                                        (click)="downloadTemplate('frt')">Freight Shipments
                Reporting
                Template</a></li>
              <li class="usa-footer__secondary-link"><a target="" href="javascript:void(0)"
                                                        (click)="downloadTemplate('frtDlvry')">Freight Delivery
                Report
                Template</a></li>
            </ul>
            <h4 class="usa-footer__primary-link">Household Goods Batch Upload Templates</h4>
            <ul class="usa-list usa-list--unstyled">
              <li class="usa-footer__secondary-link"><a target="" href="javascript:void(0)"
                                                        (click)="downloadTemplate('hhg')">CHAMP Shipment Reporting
                Template</a></li>
              <li class="usa-footer__secondary-link"><a target="" href="javascript:void(0)"
                                                        (click)="downloadTemplate('sit')">CHAMP SIT Reporting
                Template</a></li>
              <li class="usa-footer__secondary-link"><a target="" href="javascript:void(0)"
                                                        (click)="downloadTemplate('carrier')">CHAMP GSA 3080 Reporting
                                                        Template</a></li>
              <li class="usa-footer__secondary-link"><a target="" href="javascript:void(0)"
                                                        (click)="downloadTemplate('hhg_xtos')">CHAMP XTOS Reporting
                Template</a></li>
            </ul>
          </section>
        </div>
        <div class="mobile-lg:grid-col-6 desktop:grid-col-3">
          <section class="usa-footer__primary-content usa-footer__primary-content--collapsible">
            <h4 class="usa-footer__primary-link">TMSS 2.0 API</h4>
            <ul class="usa-list usa-list--unstyled">
              <li class="usa-footer__secondary-link">
                <a target="_blank" href="https://open.gsa.gov/api/ratequeryhhg">Household Goods Rate Query API</a>
              </li>
              <li class="usa-footer__secondary-link">
                <a target="_blank" href="https://open.gsa.gov/api/ratequeryfrt/">Freight Rate Query API</a>
              </li>
            </ul>
          </section>
        </div>
      </div>
    </div>
  </div>
  <div class="usa-footer__secondary-section">
    <div class="grid-container">
      <div class="grid-row grid-gap">
        <div class="usa-footer__logo grid-row mobile-lg:grid-col-8 mobile-lg:grid-gap-2">
          <div class="mobile-lg:grid-col-auto" style="cursor: pointer;">
            <img class="usa-footer__logo-img" src="/assets/images/gsa-logo.jpg" routerLink="/landing" alt="gsa-logo">
          </div>
          <div class="mobile-lg:grid-col-auto">
            <p class="usa-footer__logo-heading define-footer-name-link">
              tmss.gsa.gov
            </p>
            <p class="usa-footer__logo-heading define-footer-name">
              An Offical Website of the <a href="https://gsa.gov"><span class="define-underline">General Services Administration</span><span>
                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                  <use xlink:href="/assets/uswds/img/sprite.svg#launch"></use>
                </svg>
              </span></a>
            </p>
          </div>
          <h5 class="mobile-lg:grid-col-12 padding-top-1 define-warning-message">*** WARNING ***</h5>
          <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6" style="font-size: 0.6em;">This is a U.S. General Services Administration computer system that is "FOR OFFICIAL USE ONLY".
            This system is subject to monitoring. Therefore, no expectation of privacy is to be assumed. Individuals found performing
            unauthorized activities are subject to disciplinary action including criminal prosecution. <a target="_blank" class="regulations" aria-label="Click here to open Policy Regulations"
            href="https://www.gsa.gov/website-information/website-policies" role="button"> Policy &amp; Regulations</a></div>
        </div>
        <div class="usa-footer__contact-links mobile-lg:grid-col-4">
          <div class="usa-footer__social-links grid-row grid-gap-1">
            <div class="grid-col-auto">
              <a class="usa-social-link" href="https://www.facebook.com/gsa" target="_blank"
              ><img
                class="usa-social-link__icon"
                src="/assets/img/usa-icons/facebook.svg"
                alt="Facebook"
              /></a>
            </div>
            <div class="grid-col-auto">
              <a class="usa-social-link" href="https://twitter.com/usgsa" target="_blank"
              ><img
                class="usa-social-link__icon"
                src="/assets/img/usa-icons/twitter.svg"
                alt="Twitter"
              /></a>
            </div>
            <div class="grid-col-auto">
              <a class="usa-social-link" href="https://www.youtube.com/usgsa" target="_blank"
              ><img
                class="usa-social-link__icon"
                src="/assets/img/usa-icons/youtube.svg"
                alt="YouTube"
              /></a>
            </div>
            <div class="grid-col-auto">
              <a class="usa-social-link" href="https://www.instagram.com/usgsa" target="_blank"
              ><img
                class="usa-social-link__icon"
                src="/assets/img/usa-icons/instagram.svg"
                alt="Instagram"
              /></a>
            </div>
            <div class="grid-col-auto">
              <a class="usa-social-link" href="https://www.gsa.gov/blog" target="_blank"
              ><img
                class="usa-social-link__icon"
                src="/assets/img/usa-icons/rss_feed.svg"
                alt="RSS"
              /></a>
            </div>
          </div>
          <h3 class="usa-footer__contact-heading">Join the Conversation</h3>
          <address class="usa-footer__address define-address-information">
            <div class="usa-footer__contact-info grid-row grid-gap">
              <div class="grid-col-auto">
                <a href="tel:1-800-555-5555">1-866-668-3472</a>
              </div>
              <div class="grid-col-auto">
                <a href="mailto:info@agency.gov">gsatmsshelp&#64;gsa.gov</a>
              </div>
            </div>
          </address>
        </div>
      </div>
    </div>
  </div>
</footer>
<div class="usa-identifier">
  <section
    class="usa-identifier__section usa-identifier__section--masthead"
    aria-label="Agency identifier,"
  >
    <div class="usa-identifier__container">
      <section
        class="usa-identifier__identity"
        aria-label="Agency description,"
      >
        <p class="usa-identifier__identity-domain">tmss.gsa.gov</p>
        <p class="usa-identifier__identity-disclaimer">
          An official website of the <a href="https://www.gsa.gov/" target="_blank">U.S. General Services Administration</a>
        </p>
      </section>
    </div>
  </section>
  <nav
    class="usa-identifier__section usa-identifier__section--required-links"
    aria-label="Important links,"
  >
    <div class="usa-identifier__container">
      <ul class="usa-identifier__required-links-list">
        <li class="usa-identifier__required-links-item">
          <a
            href="https://www.gsa.gov/about-us"
            target="_blank"
            class="usa-identifier__required-link usa-link"
          >About GSA</a
          >
        </li>
        <li class="usa-identifier__required-links-item">
          <a href="https://www.gsa.gov/website-information/accessibility-statement"
             target="_blank"
             class="usa-identifier__required-link usa-link"
          >Accessibility statement</a
          >
        </li>
        <li class="usa-identifier__required-links-item">
          <a href="https://www.gsa.gov/reference/freedom-of-information-act-foia"
             target="_blank"
             class="usa-identifier__required-link usa-link"
          >FOIA requests</a
          >
        </li>
        <li class="usa-identifier__required-links-item placeholder">
          PLACEHOLDER
        </li>
        <li class="usa-identifier__required-links-item ">
          <a href="https://www.gsaig.gov/"
             target="_blank"
             class="usa-identifier__required-link usa-link"
          >Office of the Inspector General</a
          >
        </li>
        <li class="usa-identifier__required-links-item placeholder">
          PLACEHOLDER
        </li>
        <li class="usa-identifier__required-links-item">
          <a href="https://www.gsa.gov/website-information/website-policies"
             target="_blank"
             class="usa-identifier__required-link usa-link"
          >Privacy policy</a
          >
        </li>
      </ul>
    </div>
  </nav>
  <section
    class="usa-identifier__section usa-identifier__section--usagov"
    aria-label="U.S. government information and services,"
  >
    <div class="usa-identifier__container">
      <div class="usa-identifier__usagov-description">
        Looking for U.S. government information and services?
      </div>
      &nbsp;
      <a href="https://www.usa.gov/" class="usa-link" target="_blank">Visit USA.gov</a>
    </div>
  </section>
</div>

